export const ACTING_COMPANY_ID = "acting-company-id";
